// Canonical gate for exposing `window.__TEST_STORES__`.
//
// The renderer entry (`main.tsx`) and `App.tsx` attach live store / schema /
// navigation / rename internals to `window.__TEST_STORES__` so E2E + screenshot
// specs can drive the app. A bare `typeof window !== 'undefined'` check is true
// in every renderer — including shipped production and the web demo — which
// needlessly exposes destructive seams (e.g. `navRename`, `navIndexInvalidator`)
// to anything running in the renderer.
//
// Reuse the project's existing test/dev predicate, surfaced from the preload as
// `window.electronAPI.testMode.isTestMode()` (true only when SQL_STUDIO_TEST=1
// or NODE_ENV=test; the web shim returns false). Same gate `sessions/index.ts`
// already uses for the same global, so this stays consistent and non-breaking
// for the E2E/screenshot runs that set those env vars.

export type TestModeWindowLike = {
  electronAPI?: {
    testMode?: {
      isTestMode?: () => boolean;
    };
  };
};

export function isTestStoreExposureEnabled(
  win: TestModeWindowLike | undefined | null,
): boolean {
  if (!win) return false;
  try {
    return win.electronAPI?.testMode?.isTestMode?.() === true;
  } catch {
    return false;
  }
}
